import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { newModalStyle } from "../../reusable/styles";
import LabelWithHR from "../../common/labels/labelWithHR";
import Style from "./modalResetTicket.module.css";
import Button from "../../common/button/button";

const ModalResetTicket = (props) => {
  const { t } = useTranslation();
  const [keepHolderData, setKeepHolderData] = useState(false);

  return (
    <Modal
      open={props.open}
      closeOnEsc
      onClose={props.close}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <div className="modal__title">
        {t("Violations.resetTicket")}
      </div>

      <div style={{ marginTop: 20 }}>
        <div style={{ marginTop: 10, fontSize: 15 }}>
          {t("ModalResetTicket.areYouSure")}
        </div>

        <div style={{ marginTop: 5, fontSize: 14, color: "#666" }}>
          {t("ModalResetTicket.ticketNumber")}: <b>{props.ticket?.number}</b>
        </div>

        <div style={{ marginTop: 15, display: "flex", alignItems: "center", gap: 8, fontSize: 14 }}>
          <input
            type="checkbox"
            id="keepHolderData"
            checked={keepHolderData}
            onChange={(e) => setKeepHolderData(e.target.checked)}
          />
          <label htmlFor="keepHolderData" style={{ cursor: "pointer" }}>
            {t("ModalResetTicket.keepHolderData")}
          </label>
        </div>
      </div>

      <div className={Style.buttonContainer} style={{ marginTop: 30 }}>
        <Button
          style={{ width: "35%" }}
          buttonStyle={{ width: "100%" }}
          variant="secondary"
          text={t("ModalResetTicket.cancel")}
          onClick={props.close}
        />

        <Button
          style={{ width: "35%" }}
          buttonStyle={{ width: "100%" }}
          text={t("ModalResetTicket.reset")}
          onClick={() => props.onConfirm(keepHolderData)}
        />
      </div>
    </Modal>
  );
};

export default ModalResetTicket;
